import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDocumentCenterData, useFilteredDocuments } from './utils/hooks';

export const IndexRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { documents } = useDocumentCenterData();
  const { types, categories } = useFilteredDocuments();

  useEffect(() => {
    if (types.length === 0 || documents.length === 0) return;

    const search = searchParams.toString();
    const typeMap = Object.fromEntries(types.map((t) => [t.id, t]));

    for (const category of categories) {
      const docsInCategory = documents.filter((doc) => {
        const type = typeMap[doc.document_type_id];
        return type?.document_category_id === category.id;
      });

      if (docsInCategory.length > 0) {
        const firstDoc = docsInCategory[0];
        navigate(
          {
            pathname: `/documents/${firstDoc.id}`,
            search,
          },
          { replace: true },
        );
        return;
      }
    }
  }, [categories, documents, types, navigate, searchParams]);

  return null;
};
